export default __webpack_public_path__ + "static/media/img-0511-croatia-full-face.c8015d5f.png";